<div #mapViewNode [style.height]="bodyHeightAsString$|async">
</div>
